import React from 'react';
import { Code2, Box, Users, Settings, Briefcase, FileCode } from 'lucide-react';
import './SaaSDevelopment.css';

const CustomSoftware = () => {
  return (
    <div className="saas-page">
      <section className="hero-section">
        <div className="hero-content">
          <div className="hero-copy">
            <span className="eyebrow">Bespoke Solutions</span>
            <h1>Tailor-Made Software to Solve Your Unique Challenges</h1>
            <p>
              Off-the-shelf software often falls short. We build custom platforms 
              specifically designed to fit your unique business workflows.
            </p>
            <div className="hero-actions">
              <a className="button primary" href="#contact">Start Your Project</a>
              <a className="button secondary" href="#industries">See Industries</a>
            </div>
          </div>
          <div className="hero-panel">
            <div className="panel-card panel-gradient">
              <Box className="icon" />
              <h3>Built from Scratch</h3>
              <p>No bloated features. Only the tools your team needs to succeed.</p>
            </div>
          </div>
        </div>
      </section>

      <section id="industries" className="section">
        <div className="section-heading">
          <span className="eyebrow">Our Focus</span>
          <h2>Software that adapts to you.</h2>
          <p>We do not just write code; we solve business problems by understanding your operations from the ground up.</p>
        </div>

        <div className="capabilities-grid">
          <div className="capability-card">
            <div className="cap-icon"><Briefcase size={24} /></div>
            <h3>ERP Systems</h3>
            <p>Unified platforms to manage everything from HR and finance to supply chain.</p>
          </div>
          <div className="capability-card">
            <div className="cap-icon"><Users size={24} /></div>
            <h3>Internal Portals</h3>
            <p>Secure dashboards for employees to collaborate, track tasks, and share data.</p>
          </div>
          <div className="capability-card">
            <div className="cap-icon"><Code2 size={24} /></div>
            <h3>Legacy Modernization</h3>
            <p>Updating old systems to modern architectures without losing critical data.</p>
          </div>
          <div className="capability-card">
            <div className="cap-icon"><Settings size={24} /></div>
            <h3>Workflow Automation</h3>
            <p>Transforming repetitive manual tasks into efficient automated processes.</p>
          </div>
        </div>
      </section>

      <section className="section bg-glass">
        <div className="solutions-container">
          <div className="solution-row">
            <div className="solution-copy">
              <h3>Future-Proof MVP Development</h3>
              <p>
                Launching a new venture? We help you build a Minimum Viable Product 
                that is ready to scale the moment you achieve product-market fit.
              </p>
              <ul className="feature-list">
                <li><FileCode size={18} /> Clean Code Architecture</li>
                <li><FileCode size={18} /> Comprehensive Documentation</li>
                <li><FileCode size={18} /> Easy Handoff Support</li>
              </ul>
            </div>
            <div className="solution-media">
               <div className="panel-card panel-glow">
                <Code2 size={64} className="icon" />
              </div>
            </div>
          </div>
        </div>
      </section>

      <div className="metrics-grid">
        <div className="metric-item">
          <strong>100%</strong>
          <span>Ownership of Code</span>
        </div>
        <div className="metric-item">
          <strong>30%</strong>
          <span>Boost in Efficiency</span>
        </div>
        <div className="metric-item">
          <strong>Zero</strong>
          <span>Licensing Fees</span>
        </div>
        <div className="metric-item">
          <strong>Agile</strong>
          <span>Methodology</span>
        </div>
      </div>

      <section className="cta-section">
        <div className="cta-content">
          <h2>Have a complex problem?</h2>
          <p>We have the expertise to build the custom software solution you need.</p>
          <a className="button primary" href="#contact">Get a Free Consultation</a>
        </div>
      </section>
    </div>
  );
};

export default CustomSoftware;
